









































































































































































import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import { Getter, Action, Mutation } from 'vuex-class'
import {
    CardIndex,
    Options,
    BaseCard,
    isOptionsCard,
    isListCard,
    isParamCard
} from '@/entities/conversation'
import {
    ensureSuffix
} from '@/transforms/conversation'
import {
    ContextualData,
    GlobalData,
    validateLeadQuestionSpec
} from '../ConversationValidator'
import OptionsEditor from './OptionsEditor.vue'
import FlowJumpEditor from './FlowJumpEditor.vue'
import ReferenceInput from './ReferenceInput.vue'
import {
    Dict
} from '@/entities'
import CustomFieldOpen from "@/components/CustomFieldOpen.vue";
import { FieldInterpolation, getFieldInterpolations } from "@/utils/customFields";

/*
    This displays the list question but also allows
    editing of jumps to flows for each option
*/

@Component<BaseCardView>({
    components: {
        CustomFieldOpen,
        OptionsEditor,
        FlowJumpEditor,
        ReferenceInput
    }
})
export default class BaseCardView extends Vue {

    @Prop(Boolean) public hasScorecardFeature!: boolean // todo old v2, remove after migration
    @Prop(Boolean) public linkToScorecard!: boolean // todo old v2, remove after migration
    @Prop({type: Number, default: 0}) public scorecardId!: number // v3 scorecard
    @Prop(Object) public card!: BaseCard
    @Prop(Object) public cardIndex!: CardIndex
    @Prop(Number) public caseIndex?: number
    @Prop(Boolean) public inBranch?: boolean
    @Prop(Boolean) public flow!: boolean
    @Prop(Object) public scope!: any
    @Prop(Boolean) public canEditOptionKeys!: boolean

    // so we know if we under detractor & passive
    @Prop({type: String, default: ''}) public scorecardTab!: string
    @Getter public getContextual!: Dict<ContextualData>
    @Getter public getGlobal!: GlobalData

    @Action public removeCard!: (index: CardIndex) => void

    @Getter public getSurvey
    @Mutation public setSurveyField
    @Mutation public touchEditedNow

    public paramLocked = true
    public initialParam = ''

    public get missingCsatLabels() {
        return [
            'csat_very_satisfied',
            'csat_satisfied',
            'csat_neutral',
            'csat_unsatisfied',
            'csat_very_unsatisfied',
        ].filter(label => (this.getSurvey[label]?.length ?? 0) == 0)
    }

    public get canEditBadge() {
        // must be list or scorecard type card
        return !!(['list'].includes(this.card.type) &&
            this.hasScorecardFeature && this.scorecardTab)
    }

    public get collectParamFirst() {
        return isParamCard(this.card) && !this.card.param
    }

    public get context(): ContextualData | undefined {
        const { sectionIndex, cardIndex } = this.cardIndex
        const cursorParts: number[] = [sectionIndex, cardIndex]
        if (this.caseIndex !== undefined) { cursorParts.push(this.caseIndex) }
        return this.getContextual[cursorParts.join('/')]
    }

    public get errors() {
        if (this.card.hasOwnProperty('param') && this.card['param'] === 'leadQuestion') {
            return validateLeadQuestionSpec(this.cardIndex, this.card['say'], this.getGlobal.scope)
        }

        return this.context && this.context.errors || {}
    }

    public get maxOptions(): number {
        switch (this.card.type) {
            case 'csat':
            case 'ces':
                return 5
            case 'nps':
            case 'list':
                return 10
            default:
                return 7
        }
    }

    public toggleLinkToScorecard(event: Event) {
        const checked = (event.target as HTMLInputElement).checked
        this.$emit('toggleLinkToScorecard', checked)
    }

    @Watch('scorecardTab')
    public onScorecardTabChange() {
        if (!this.scorecardTab && 'options' in this.card) {
            this.$emit('toggleLinkToScorecard', false)
        }
    }

    public customFieldSelected(say: string) {
        this.$emit('change', {
            ...this.card,
            say
        });

        (this.$refs.input as HTMLInputElement).focus()
    }

    public updateSay(event: Event) {
        const target = event.target as HTMLInputElement
        const say = target.value
        const field = getFieldInterpolations(say).find(
            ({ incomplete }) => incomplete
        )

        if (field) {
            this.$root.$emit('customfield:show', target, field, this.scope, this.customFieldSelected)
        } else {
            this.$root.$emit('customfield:hide');
        }

        this.$emit('change', {
            ...this.card,
            say
        })
    }

    public updateLink(event: Event) {
        let value = (event.target as HTMLInputElement).value
        if (value.includes('http://')) {
            value = value.replace('http://', 'https://')
        }

        this.$emit('change', {
            ...this.card,
            link: value
        })
    }

    public updateParam(param: string) {

        const type = this.card.type

        if (isOptionsCard(this.card) && !isListCard(this.card)) {
            param = ensureSuffix(param.trim(), `_${type}`)
        }

        this.$emit('change', {
            ...this.card,
            param
        })
        if (this.inBranch) {
            this.$emit('syncParam', {...this.cardIndex, param})
        }
    }

    public handleInputParam(value: string) {
        if (!this.paramLocked) {
            this.updateParam(value)
        }
    }

    public handleSubmitParam(value: string) {
        if (!this.paramLocked) {
            this.updateParam(value)
        }
    }

    public handleChangeInitialParam(value: string) {
        this.initialParam = value
    }

    public handleSubmitInitialParam(value: string) {
        this.updateParam(value)
    }

    public applyInitialParam() {
        this.updateParam(this.initialParam)
    }

    public updateOptions(options: Options) {
        this.$emit('change', {
            ...this.card,
            options
        })
    }

    public updateJump(jump: string) {
        this.$emit('change', {
            ...this.card,
            jump
        })
    }

    public cancel() {
        this.removeCard(this.cardIndex)
    }

    public unlockParam() {
        if (
            this.paramLocked &&
            confirm(
                'Modifying the question key may affect your data reporting. ' +
                'Are you sure you want to unlock editing?'
            )
        ) {
            this.paramLocked = false
        }
    }

    public updateCsatLabel(field, draftValue) {
        this.$root.$emit('set-langEdited')
        this.touchEditedNow()
        const value = draftValue.slice(0, 25)
        this.setSurveyField({field, value})
    }
}
